/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![SlashPlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABcklEQVR4nN2VuU7DQBCGU3DUXAU8AYiHcGspnp0x0mYmIFpXQIWgSm864GFSUBLxBog3AJpAT1AUtCYW64M465iGlVayPMc38+/Vav2bobVeUcRXgPyiSCZ1JhA/K5LY5CoAjKFuYlWccQGwSOUqP1FeyzpwSMB3tgxA0sn7LAL4BJD9NM7zvCVF/NgYAFCuM3GhnJX51QTwO9HxRhrTbh+uAfKwMQAQn2Rj+PY3X2cAoDxFUbSc+gcH3V1AHjUHCMXP+KP0Z/m7AVD6tq+BWZ19AMqFUrLja70FyD1AHs8NAOQREe/Z29LIZdkv87kC5HMHgMzclmF4tJ10RfKgkAeFxLMAgPKmtV5Pfcy3+WdVP8zHuwJOM9oj39ial8XPDTA6G71Tu1kHsx5lmtcDkHRSm+/7q+aCS2zTyhPNqy/FnzWZPhaVpzkIuptJQciD6pMv984PDiD3akn0/WRKXNUJII/NIjsDFh1/D0AeZDSfji8mpWk0iRC+8QAAAABJRU5ErkJggg==)
 */
export const SlashPlusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19 14a1 1 0 0 1 1 1v3h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M22 13.67c0 .12-.33.17-.39.06A2.87 2.87 0 0 0 19 12a3 3 0 0 0-3 3v.5a.5.5 0 0 1-.5.5H15a3 3 0 0 0-3 3c0 1.2.7 2.1 1.73 2.61.11.06.06.39-.06.39H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v8.67Zm-4.21-8.3a.25.25 0 0 0-.22-.37h-3.13a.75.75 0 0 0-.66.38L6.21 18.63c-.1.16.03.37.22.37h3.13c.27 0 .52-.14.66-.38l7.57-13.25Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
